var map = {
	"./icon1.svg": 7736,
	"./icon2.svg": 6986,
	"./icon3.svg": 6388,
	"./icon4.svg": 4735,
	"./icon5.svg": 8742,
	"./icon6.svg": 4430,
	"./menu.svg": 3881
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7886;